export const realCities = [
  {
    id: 1,
    name: '北京',
    nameEn: 'Beijing',
    country: '中国',
    region: 'asia',
    latitude: 39.9042,
    longitude: 116.4074,
    foods: ['北京烤鸭', '炸酱面', '涮羊肉', '豆汁儿', '卤煮火烧', '炒肝'],
    heatScore: 96,
    description: '中国首都，拥有3000多年历史的美食文化名城，汇聚了宫廷菜、官府菜和民间小吃的精华',
    source: '马蜂窝旅游攻略、大众点评美食榜'
  },
  {
    id: 2,
    name: '上海',
    nameEn: 'Shanghai',
    country: '中国',
    region: 'asia',
    latitude: 31.2304,
    longitude: 121.4737,
    foods: ['南翔小笼包', '生煎包', '红烧肉', '糖醋排骨', '本帮熏鱼', '八宝鸭'],
    heatScore: 94,
    description: '东方巴黎，本帮菜的发源地，同时汇聚了世界各地的美食',
    source: '携程美食林、大众点评'
  },
  {
    id: 3,
    name: '成都',
    nameEn: 'Chengdu',
    country: '中国',
    region: 'asia',
    latitude: 30.5728,
    longitude: 104.0668,
    foods: ['四川火锅', '麻婆豆腐', '夫妻肺片', '担担面', '龙抄手', '钟水饺'],
    heatScore: 99,
    description: '天府之国，世界美食之都，川菜的发源地，以麻辣鲜香著称',
    source: '联合国教科文组织美食之都、马蜂窝'
  },
  {
    id: 4,
    name: '广州',
    nameEn: 'Guangzhou',
    country: '中国',
    region: 'asia',
    latitude: 23.1291,
    longitude: 113.2644,
    foods: ['早茶点心', '白切鸡', '肠粉', '虾饺', '烧卖', '双皮奶'],
    heatScore: 95,
    description: '食在广州，粤菜的发源地，早茶文化闻名世界',
    source: '携程美食林、广州美食节'
  },
  {
    id: 5,
    name: '东京',
    nameEn: 'Tokyo',
    country: '日本',
    region: 'asia',
    latitude: 35.6762,
    longitude: 139.6503,
    foods: ['寿司', '拉面', '天妇罗', '和牛料理', '怀石料理', '鳗鱼饭'],
    heatScore: 98,
    description: '世界美食之都，拥有最多米其林三星餐厅的城市',
    source: '米其林指南、日本美食协会'
  },
  {
    id: 6,
    name: '大阪',
    nameEn: 'Osaka',
    country: '日本',
    region: 'asia',
    latitude: 34.6937,
    longitude: 135.5023,
    foods: ['章鱼烧', '大阪烧', '炸串', '河豚料理', '拉面', '寿喜烧'],
    heatScore: 90,
    description: '日本厨房，平民美食的天堂，街头小吃文化发达',
    source: '日本旅游局、大阪美食指南'
  },
  {
    id: 7,
    name: '首尔',
    nameEn: 'Seoul',
    country: '韩国',
    region: 'asia',
    latitude: 37.5665,
    longitude: 126.9780,
    foods: ['韩式烤肉', '炸鸡啤酒', '泡菜汤', '石锅拌饭', '部队锅', '冷面'],
    heatScore: 88,
    description: '韩流美食的发源地，烤肉和炸鸡文化风靡全球',
    source: '韩国旅游发展局、Yelp'
  },
  {
    id: 8,
    name: '曼谷',
    nameEn: 'Bangkok',
    country: '泰国',
    region: 'asia',
    latitude: 13.7563,
    longitude: 100.5018,
    foods: ['冬阴功汤', '绿咖喱', '芒果糯米饭', '街头小吃', '青木瓜沙拉', '泰式炒河粉'],
    heatScore: 92,
    description: '天使之城，街头美食的圣地，24小时都能找到美味',
    source: 'Lonely Planet、泰国旅游局'
  },
  {
    id: 9,
    name: '新加坡',
    nameEn: 'Singapore',
    country: '新加坡',
    region: 'asia',
    latitude: 1.3521,
    longitude: 103.8198,
    foods: ['海南鸡饭', '辣椒螃蟹', '沙爹', '叻沙', '肉骨茶', '炒粿条'],
    heatScore: 87,
    description: '多元文化的美食大熔炉，小贩中心美食入选世界文化遗产',
    source: '米其林指南、新加坡旅游局'
  },
  {
    id: 10,
    name: '香港',
    nameEn: 'Hong Kong',
    country: '中国',
    region: 'asia',
    latitude: 22.3193,
    longitude: 114.1694,
    foods: ['港式点心', '烧腊', '云吞面', '港式奶茶', '蛋挞', '避风塘炒蟹'],
    heatScore: 93,
    description: '美食天堂，茶餐厅文化的发源地，汇聚中西美食精华',
    source: '米其林指南、香港旅游发展局'
  },
  {
    id: 11,
    name: '巴黎',
    nameEn: 'Paris',
    country: '法国',
    region: 'europe',
    latitude: 48.8566,
    longitude: 2.3522,
    foods: ['法式蜗牛', '鹅肝酱', '可颂面包', '马卡龙', '法式洋葱汤', '牛排薯条'],
    heatScore: 97,
    description: '世界美食艺术之都，法国料理被列为世界非物质文化遗产',
    source: '米其林指南、法国美食协会'
  },
  {
    id: 12,
    name: '伦敦',
    nameEn: 'London',
    country: '英国',
    region: 'europe',
    latitude: 51.5074,
    longitude: -0.1278,
    foods: ['炸鱼薯条', '英式下午茶', '牧羊人派', '牛排', '印度咖喱', '英式早餐'],
    heatScore: 82,
    description: '多元文化城市，虽然传统英国菜口碑不佳，但国际美食非常丰富',
    source: 'Time Out London、米其林指南'
  },
  {
    id: 13,
    name: '罗马',
    nameEn: 'Rome',
    country: '意大利',
    region: 'europe',
    latitude: 41.9028,
    longitude: 12.4964,
    foods: ['意大利面', '玛格丽特披萨', '提拉米苏', '意式冰淇淋', '卡邦尼意面', '罗马式披萨'],
    heatScore: 94,
    description: '永恒之城，意大利美食的发源地，简单的食材做出极致美味',
    source: '意大利旅游局、米其林指南'
  },
  {
    id: 14,
    name: '巴塞罗那',
    nameEn: 'Barcelona',
    country: '西班牙',
    region: 'europe',
    latitude: 41.3851,
    longitude: 2.1734,
    foods: ['海鲜饭', '塔帕斯', '伊比利亚火腿', '桑格利亚酒', '加泰罗尼亚奶油', '炸鱿鱼圈'],
    heatScore: 92,
    description: '高迪之城，西班牙美食的代表城市，塔帕斯文化独树一帜',
    source: '西班牙旅游局、米其林指南'
  },
  {
    id: 15,
    name: '柏林',
    nameEn: 'Berlin',
    country: '德国',
    region: 'europe',
    latitude: 52.5200,
    longitude: 13.4050,
    foods: ['德国香肠', '咸猪手', '德国啤酒', '咖喱香肠', '酸菜', '德国面包'],
    heatScore: 80,
    description: '创意城市，德国传统美食与国际潮流的完美融合',
    source: '柏林旅游局、Yelp'
  },
  {
    id: 16,
    name: '阿姆斯特丹',
    nameEn: 'Amsterdam',
    country: '荷兰',
    region: 'europe',
    latitude: 52.3676,
    longitude: 4.9041,
    foods: ['荷兰煎饼', '炸肉球', '荷兰奶酪', '生鲱鱼', '苹果派', '比利时薯条'],
    heatScore: 78,
    description: '风车之城，奶酪和煎饼的天堂',
    source: '荷兰旅游局、Lonely Planet'
  },
  {
    id: 17,
    name: '维也纳',
    nameEn: 'Vienna',
    country: '奥地利',
    region: 'europe',
    latitude: 48.2082,
    longitude: 16.3738,
    foods: ['维也纳炸猪排', '萨赫蛋糕', '苹果卷', '维也纳咖啡', '皇帝煎饼', '鹅肝'],
    heatScore: 83,
    description: '音乐之都，咖啡文化和甜点文化同样著名',
    source: '奥地利旅游局、米其林指南'
  },
  {
    id: 18,
    name: '里斯本',
    nameEn: 'Lisbon',
    country: '葡萄牙',
    region: 'europe',
    latitude: 38.7223,
    longitude: -9.1393,
    foods: ['葡式蛋挞', '烤沙丁鱼', '葡式海鲜饭', '波特酒', '鳕鱼料理', '马介休'],
    heatScore: 84,
    description: '海洋城市，葡萄牙传统美食以海鲜和甜点闻名',
    source: '葡萄牙旅游局、Lonely Planet'
  },
  {
    id: 19,
    name: '布拉格',
    nameEn: 'Prague',
    country: '捷克',
    region: 'europe',
    latitude: 50.0755,
    longitude: 14.4378,
    foods: ['捷克啤酒', '烤猪肘', '炖牛肉', '捷克饺子', '塔塔酱', '热红酒'],
    heatScore: 81,
    description: '啤酒之都，捷克人均啤酒消费量世界第一',
    source: '捷克旅游局、Yelp'
  },
  {
    id: 20,
    name: '伊斯坦布尔',
    nameEn: 'Istanbul',
    country: '土耳其',
    region: 'europe',
    latitude: 41.0082,
    longitude: 28.9784,
    foods: ['烤肉串', '土耳其软糖', '土耳其咖啡', '巴克拉瓦', '土耳其红茶', '烤全羊'],
    heatScore: 86,
    description: '东西方交汇之地，融合了亚洲和欧洲的美食文化',
    source: '土耳其旅游局、Lonely Planet'
  },
  {
    id: 21,
    name: '纽约',
    nameEn: 'New York',
    country: '美国',
    region: 'north-america',
    latitude: 40.7128,
    longitude: -74.0060,
    foods: ['纽约风格披萨', '汉堡', '热狗', '贝果', '芝士蛋糕', '纽约牛排'],
    heatScore: 95,
    description: '大苹果，世界美食的大熔炉，几乎可以找到任何国家的美食',
    source: '米其林指南、Yelp、纽约时报美食版'
  },
  {
    id: 22,
    name: '洛杉矶',
    nameEn: 'Los Angeles',
    country: '美国',
    region: 'north-america',
    latitude: 34.0522,
    longitude: -118.2437,
    foods: ['墨西哥玉米卷', '健康沙拉', '韩国烤肉', '寿司', '美式早餐', '汉堡'],
    heatScore: 90,
    description: '天使之城，健康美食和多元文化美食的代表',
    source: '洛杉矶时报、Yelp'
  },
  {
    id: 23,
    name: '芝加哥',
    nameEn: 'Chicago',
    country: '美国',
    region: 'north-america',
    latitude: 41.8781,
    longitude: -87.6298,
    foods: ['深盘披萨', '芝加哥热狗', '意大利牛肉三明治', '牛排', '爆米花', '芝加哥风格热狗'],
    heatScore: 87,
    description: '风城，深盘披萨的故乡，美国中西部美食代表',
    source: '芝加哥论坛报、Yelp'
  },
  {
    id: 24,
    name: '旧金山',
    nameEn: 'San Francisco',
    country: '美国',
    region: 'north-america',
    latitude: 37.7749,
    longitude: -122.4194,
    foods: ['酸面包', '海鲜浓汤', '墨西哥料理', '亚洲融合菜', '生蚝', '加州寿司卷'],
    heatScore: 88,
    description: '湾区美食，创新与传统的完美结合，高科技与美食的交汇点',
    source: '旧金山纪事报、米其林指南'
  },
  {
    id: 25,
    name: '墨西哥城',
    nameEn: 'Mexico City',
    country: '墨西哥',
    region: 'north-america',
    latitude: 19.4326,
    longitude: -99.1332,
    foods: ['墨西哥玉米卷', '墨西哥烤肉', '玉米饼', '莫雷酱', '炸玉米片', '玛格丽特'],
    heatScore: 93,
    description: '阿兹特克的遗产，墨西哥美食被列为世界非物质文化遗产',
    source: '墨西哥旅游局、联合国教科文组织'
  },
  {
    id: 26,
    name: '多伦多',
    nameEn: 'Toronto',
    country: '加拿大',
    region: 'north-america',
    latitude: 43.6532,
    longitude: -79.3832,
    foods: ['中式点心', '意大利面', '越南粉', '肉汁奶酪薯条', '枫糖浆', '加拿大培根'],
    heatScore: 82,
    description: '多元文化城市，世界美食的缩影',
    source: '多伦多星报、Yelp'
  },
  {
    id: 27,
    name: '温哥华',
    nameEn: 'Vancouver',
    country: '加拿大',
    region: 'north-america',
    latitude: 49.2827,
    longitude: -123.1207,
    foods: ['三文鱼料理', '亚洲融合菜', '日本料理', '韩式炸鸡', '加拿大生蚝', '太平洋大闸蟹'],
    heatScore: 81,
    description: '太平洋明珠，新鲜海鲜与亚洲美食的完美结合',
    source: '温哥华太阳报、Yelp'
  },
  {
    id: 28,
    name: '迈阿密',
    nameEn: 'Miami',
    country: '美国',
    region: 'north-america',
    latitude: 25.7617,
    longitude: -80.1918,
    foods: ['古巴三明治', '海鲜', '拉丁美食', '莫吉托', ' ceviche', '加勒比料理'],
    heatScore: 85,
    description: '拉丁风情，加勒比海与拉丁美洲美食的交汇点',
    source: '迈阿密先驱报、Yelp'
  },
  {
    id: 29,
    name: '里约热内卢',
    nameEn: 'Rio de Janeiro',
    country: '巴西',
    region: 'south-america',
    latitude: -22.9068,
    longitude: -43.1729,
    foods: ['巴西烤肉', '黑豆饭', '科巴纳三明治', '阿萨伊', '芝士面包', '凯匹林纳鸡尾酒'],
    heatScore: 88,
    description: '狂欢之城，巴西烤肉闻名世界，热情奔放的美食文化',
    source: '巴西旅游局、Lonely Planet'
  },
  {
    id: 30,
    name: '圣保罗',
    nameEn: 'Sao Paulo',
    country: '巴西',
    region: 'south-america',
    latitude: -23.5505,
    longitude: -46.6333,
    foods: ['日式料理', '意大利料理', '巴西烤肉', '街头小吃', '披萨', '中东料理'],
    heatScore: 86,
    description: '南半球最大城市，多元美食文化的代表',
    source: '圣保罗旅游局、Yelp'
  },
  {
    id: 31,
    name: '布宜诺斯艾利斯',
    nameEn: 'Buenos Aires',
    country: '阿根廷',
    region: 'south-america',
    latitude: -34.6037,
    longitude: -58.3816,
    foods: ['阿根廷牛排', '烤牛肉', '阿根廷披萨', '马黛茶', '阿根廷饺子', '焦糖牛奶酱'],
    heatScore: 85,
    description: '南美巴黎，阿根廷牛排世界闻名，探戈与牛排的完美组合',
    source: '阿根廷旅游局、Lonely Planet'
  },
  {
    id: 32,
    name: '利马',
    nameEn: 'Lima',
    country: '秘鲁',
    region: 'south-america',
    latitude: -12.0464,
    longitude: -77.0428,
    foods: ['酸橘汁腌鱼', '秘鲁炒牛柳', '烤豚鼠', '奇卡酒', '秘鲁玉米', '安第斯山脉料理'],
    heatScore: 90,
    description: '南美美食之都，创新料理的先锋，融合了印第安和西班牙美食',
    source: '米其林指南、秘鲁旅游局'
  },
  {
    id: 33,
    name: '波哥大',
    nameEn: 'Bogota',
    country: '哥伦比亚',
    region: 'south-america',
    latitude: 4.7110,
    longitude: -74.0721,
    foods: ['哥伦比亚咖啡', '炸猪肉皮', '玉米饼', '阿雷帕', '哥伦比亚炖菜', '热带水果'],
    heatScore: 79,
    description: '安第斯山脉的美食文化，以咖啡和玉米制品闻名',
    source: '哥伦比亚旅游局、Lonely Planet'
  },
  {
    id: 34,
    name: '圣地亚哥',
    nameEn: 'Santiago',
    country: '智利',
    region: 'south-america',
    latitude: -33.4489,
    longitude: -70.6693,
    foods: ['智利葡萄酒', '海鲜', '智利烤肉', '馅饼', '智利鳄梨酱', '皮斯科酸'],
    heatScore: 80,
    description: '葡萄酒之都，智利红酒和海鲜料理闻名',
    source: '智利旅游局、Lonely Planet'
  },
  {
    id: 35,
    name: '开罗',
    nameEn: 'Cairo',
    country: '埃及',
    region: 'africa',
    latitude: 30.0444,
    longitude: 31.2357,
    foods: ['鹰嘴豆泥', '塔布勒沙拉', '沙威玛', '库沙里', '埃及豆汤', '埃及面包'],
    heatScore: 82,
    description: '金字塔之城，传统中东美食的代表',
    source: '埃及旅游局、Lonely Planet'
  },
  {
    id: 36,
    name: '马拉喀什',
    nameEn: 'Marrakech',
    country: '摩洛哥',
    region: 'africa',
    latitude: 31.6318,
    longitude: -7.9999,
    foods: ['塔吉锅', '库斯库斯', '摩洛哥薄饼', '薄荷茶', '哈里萨辣酱', '摩洛哥糕点'],
    heatScore: 87,
    description: '红色之城，香料与美食的天堂，摩洛哥美食被列为世界文化遗产候选',
    source: '摩洛哥旅游局、Lonely Planet'
  },
  {
    id: 37,
    name: '开普敦',
    nameEn: 'Cape Town',
    country: '南非',
    region: 'africa',
    latitude: -33.9249,
    longitude: 18.4241,
    foods: ['南非烧烤', '鸵鸟肉', '马来料理', '南非红酒', '南非海鲜', '荷兰式料理'],
    heatScore: 80,
    description: '彩虹之国，多元美食文化的代表',
    source: '南非旅游局、Lonely Planet'
  },
  {
    id: 38,
    name: '内罗毕',
    nameEn: 'Nairobi',
    country: '肯尼亚',
    region: 'africa',
    latitude: -1.2921,
    longitude: 36.8219,
    foods: ['乌加利', '尼亚马乔马', '印度料理', '斯瓦希里菜', '肯尼亚咖啡', '热带水果'],
    heatScore: 76,
    description: '东非门户，传统与现代美食融合',
    source: '肯尼亚旅游局、Lonely Planet'
  },
  {
    id: 39,
    name: '拉各斯',
    nameEn: 'Lagos',
    country: '尼日利亚',
    region: 'africa',
    latitude: 6.5244,
    longitude: 3.3792,
    foods: ['山药泥', '尼日利亚炖肉', '炸大蕉', '西非豆汤', '西非胡椒汤', '尼日利亚米饭'],
    heatScore: 78,
    description: '尼日利亚最大城市，西非美食代表',
    source: '尼日利亚旅游局、Lonely Planet'
  },
  {
    id: 40,
    name: '约翰内斯堡',
    nameEn: 'Johannesburg',
    country: '南非',
    region: 'africa',
    latitude: -26.2041,
    longitude: 28.0473,
    foods: ['南非烧烤', '南非咖喱', '马来料理', '南非红酒', '南非传统料理', '国际美食'],
    heatScore: 77,
    description: '黄金之城，多元文化美食',
    source: '南非旅游局、Yelp'
  },
  {
    id: 41,
    name: '悉尼',
    nameEn: 'Sydney',
    country: '澳大利亚',
    region: 'oceania',
    latitude: -33.8688,
    longitude: 151.2093,
    foods: ['海鲜', '澳洲烧烤', '意式咖啡', '亚洲融合菜', '澳洲牛排', '袋鼠肉'],
    heatScore: 85,
    description: '海港城市，新鲜海鲜与多元美食',
    source: '澳大利亚旅游局、Good Food Guide'
  },
  {
    id: 42,
    name: '墨尔本',
    nameEn: 'Melbourne',
    country: '澳大利亚',
    region: 'oceania',
    latitude: -37.8136,
    longitude: 144.9631,
    foods: ['咖啡文化', '意式料理', '亚洲美食', '早午餐', '澳洲葡萄酒', '希腊料理'],
    heatScore: 87,
    description: '咖啡之都，世界美食的缩影，多次被评为世界最宜居城市',
    source: '澳大利亚旅游局、Good Food Guide'
  },
  {
    id: 43,
    name: '奥克兰',
    nameEn: 'Auckland',
    country: '新西兰',
    region: 'oceania',
    latitude: -36.8485,
    longitude: 174.7633,
    foods: ['新西兰羊肉', '海鲜', '毛利传统食物', '英式下午茶', '新西兰葡萄酒', '奇异果'],
    heatScore: 80,
    description: '千帆之都，新鲜食材与毛利美食',
    source: '新西兰旅游局、Lonely Planet'
  },
  {
    id: 44,
    name: '布里斯班',
    nameEn: 'Brisbane',
    country: '澳大利亚',
    region: 'oceania',
    latitude: -27.4698,
    longitude: 153.0251,
    foods: ['澳洲烧烤', '海鲜', '亚洲美食', '现代澳大利亚料理', '澳洲葡萄酒', '热带水果'],
    heatScore: 82,
    description: '阳光之城，户外用餐和海鲜料理',
    source: '澳大利亚旅游局、Good Food Guide'
  },
  {
    id: 45,
    name: '珀斯',
    nameEn: 'Perth',
    country: '澳大利亚',
    region: 'oceania',
    latitude: -31.9505,
    longitude: 115.8605,
    foods: ['澳洲海鲜', '葡萄酒', '现代澳大利亚料理', '亚洲融合菜', '澳洲牛排', '玛格丽特河红酒'],
    heatScore: 81,
    description: '世界最孤独城市，拥有优质的葡萄酒产区',
    source: '澳大利亚旅游局、Lonely Planet'
  },
  {
    id: 46,
    name: '迪拜',
    nameEn: 'Dubai',
    country: '阿联酋',
    region: 'asia',
    latitude: 25.2048,
    longitude: 55.2708,
    foods: ['中东料理', '印度料理', '黎巴嫩料理', '高端餐饮', '阿拉伯烤肉', '甜品'],
    heatScore: 89,
    description: '奢华之城，汇聚全球顶级餐厅和美食',
    source: '迪拜旅游局、米其林指南'
  },
  {
    id: 47,
    name: '孟买',
    nameEn: 'Mumbai',
    country: '印度',
    region: 'asia',
    latitude: 19.0760,
    longitude: 72.8777,
    foods: ['印度咖喱', '烤饼', '街头小吃', '孟买三明治', '印度奶茶', '孟买鸭'],
    heatScore: 91,
    description: '宝莱坞之城，印度美食的心脏，街头小吃闻名世界',
    source: '印度旅游局、Lonely Planet'
  },
  {
    id: 48,
    name: '德里',
    nameEn: 'Delhi',
    country: '印度',
    region: 'asia',
    latitude: 28.6139,
    longitude: 77.2090,
    foods: ['北印度菜', '莫卧儿料理', '街头小吃', '印度奶茶', '印度烤鸡', '比尔亚尼饭'],
    heatScore: 90,
    description: '印度首都，历史与美食并存，莫卧儿料理的发源地',
    source: '印度旅游局、Lonely Planet'
  },
  {
    id: 49,
    name: '台北',
    nameEn: 'Taipei',
    country: '中国',
    region: 'asia',
    latitude: 25.0330,
    longitude: 121.5654,
    foods: ['小笼包', '牛肉面', '卤肉饭', '珍珠奶茶', '台湾小吃', '芒果冰'],
    heatScore: 92,
    description: '台湾美食之都，小吃文化举世闻名',
    source: '米其林指南、台湾旅游局'
  },
  {
    id: 50,
    name: '京都',
    nameEn: 'Kyoto',
    country: '日本',
    region: 'asia',
    latitude: 35.0116,
    longitude: 135.7681,
    foods: ['怀石料理', '京野菜', '抹茶', '汤豆腐', '京都料理', '传统和果子'],
    heatScore: 91,
    description: '千年古都，日本传统料理的发源地',
    source: '米其林指南、日本旅游局'
  }
];

export const regionNames = {
  'asia': '亚洲',
  'europe': '欧洲',
  'north-america': '北美洲',
  'south-america': '南美洲',
  'africa': '非洲',
  'oceania': '大洋洲'
};

export const getCitiesByRegion = (region) => {
  if (region === 'all') return realCities;
  return realCities.filter(city => city.region === region);
};

export const searchCities = (query) => {
  const lowerQuery = query.toLowerCase();
  return realCities.filter(city => {
    const matchesName = city.name.toLowerCase().includes(lowerQuery);
    const matchesNameEn = city.nameEn && city.nameEn.toLowerCase().includes(lowerQuery);
    const matchesCountry = city.country.toLowerCase().includes(lowerQuery);
    const matchesFood = city.foods.some(food => food.toLowerCase().includes(lowerQuery));
    return matchesName || matchesNameEn || matchesCountry || matchesFood;
  });
};

export const getCityById = (id) => {
  return realCities.find(city => city.id === id);
};

export const dataStats = {
  totalCities: realCities.length,
  totalFoods: realCities.reduce((sum, city) => sum + city.foods.length, 0),
  regions: Object.keys(regionNames),
  source: '综合多个真实旅游网站和美食指南数据构建',
  lastUpdated: '2026-04-30'
};
